<template>
	<el-dialog
		:title="dialogTitle"
		:visible.sync="dialogVisible"
		:destroy-on-close="true"
		:close-on-click-modal="false"
		:width="schedule === 'importing1' ? '1000px' : '600px'"
		:before-close="beforeClose"
		class="batch-import-account-dialog"
	>
		<div class="dialog-title2" slot="title">
			<span>{{ dialogTitle }}</span>
			<el-divider></el-divider>
		</div>
		<!-- 未导入 -->
		<template v-if="schedule === 'not_imported'">
			<div class="topon-upload">
				<p class="topon-p">
					请先下载【<span class="template" @click="domloadBlob('template', targetMap[target] + '模板')"
						>{{ targetMap[target] + '模板' }}</span
					>】，并按照提示填入信息，填写完成后进行上传导入。
				</p>
			</div>

			<div class="upload-demo">
				<p style="padding-top: 20px; padding-left: 20px;">
					上传完善的内容，支持上传的格式为Excel表
				</p>
				<!-- :http-request="uploadSectionFile" -->
				<el-upload
					:show-file-list="false"
					:file-list="fileList"
					action="www"
					accept=".xlsx"
					:on-remove="handleRemove"
					:before-upload="beforeUpload"
					:http-request="uploadSectionFile"
					:drag="true"
				>
					<div style="padding-top: 60px;">
						<svg class="icon" aria-hidden="true" style="width: 66px; height: 66px; outline: none; box-shadow: none;">
							<use xlink:href="#icon-uploadexcel"></use>
						</svg>
						<div class="el-upload__text" style="margin-top: 20px;">将文件拖到此处，或<em>点击上传</em></div>
					</div>
				</el-upload>
			</div>
		</template>
		<!-- 导入中 -->
		<template v-if="schedule === 'importing'">
			<!-- v-if="schedule === 'importing'" -->
			<div class="uploading" style="color: #f9602d;">
				<svg class="icon" aria-hidden="true" style="width: 80px; height: 80px; outline: none; box-shadow: none;">
					<use xlink:href="#icon-uploading"></use>
				</svg>
				<span class="uploading-font">校检中...</span>
			</div>
			<div class="uploading-hdmi">
				<div style="margin-left: 15px; color: #4db764;">
					<svg class="icon" aria-hidden="true" style="width: 44px; height: 49px; outline: none; box-shadow: none;">
						<use xlink:href="#icon-greenexcel"></use>
					</svg>
				</div>
				<div style="width: 100%; margin-left: 10px;">
					<span class="uploading-sasi">{{ filename }}</span>
					<el-progress
						:percentage="parseInt(fake.progress * 100)"
						color="#55B46F"
						:format="format"
						style="width: 480px;"
					>
					</el-progress>
					<span class="uploading-kenhtid">{{ filesize }}</span>
				</div>
			</div>
			<!-- <p>{{ importRes.message }}</p>
			<div style="height: 60px;" v-loading="loading"></div> -->
		</template>

		<!-- 校检成功 -->
		<template v-if="schedule === 'importingWin'">
			<div class="uploading" style="color: #1db252;">
				<svg class="icon" aria-hidden="true" style="width: 80px; height: 80px; outline: none; box-shadow: none;">
					<use xlink:href="#icon-uploadsess"></use>
				</svg>
				<span class="uploading-font">校检成功</span>
			</div>
			<div class="uploading-hdmi">
				<div style="margin-left: 15px; color: #4db764;">
					<svg class="icon" aria-hidden="true" style="width: 44px; height: 49px; outline: none; box-shadow: none;">
						<use xlink:href="#icon-greenexcel"></use>
					</svg>
				</div>

				<div class="jhrts">
					<span class="uploading-sasi">{{ filename }}</span>
					<span class="uploading-kenhtid">{{ filesize }}</span>
				</div>
				<div>
					<el-button size="small" class="aosit" @click="checkdata">核对数据导入</el-button>
				</div>
			</div>
		</template>

		<!-- 校检失败 -->
		<template v-if="schedule === 'importinglose'">
			<div class="uploading" style="color: #fe5959;">
				<svg class="icon" aria-hidden="true" style="width: 80px; height: 80px; outline: none; box-shadow: none;">
					<use xlink:href="#icon-uploaderror"></use>
				</svg>
				<span class="uploading-font">校检失败</span>
			</div>
			<div class="uploading-hdmi">
				<div class="jhrts">
					<span class="uploading-sasi">失败原因</span>
					<span class="uploading-kenhtid" style="width: 100%;">{{ erroris }}</span>
				</div>

				<div style="display: flex; margin-right: 25px;">
					<el-button
						v-if="shuriID !== 2"
						size="small"
						class="aosit2"
						@click="domloadBlob2('template', $route.meta.title.substr(0, 2) + '-' + '失败数据')"
						>导出失败数据</el-button
					>
					<el-button size="small" class="aosit3" @click="reimport">重新导入</el-button>
				</div>
			</div>
		</template>
		<!-- 网络接口问题 -->
		<template v-if="schedule === 'importinghttp'">
			<div class="uploading" style="color: #fe5959;">
				<svg class="icon" aria-hidden="true" style="width: 80px; height: 80px; outline: none; box-shadow: none;">
					<use xlink:href="#icon-uploaderror"></use>
				</svg>
				<!-- <span class="uploading-font">校检失败</span> -->
			</div>

			<div class="uploading-hdmi">
				<div class="jhrts">
					<span class="uploading-sasi">失败原因</span>
					<span class="uploading-kenhtid" style="width: 100%;">服务器超时</span>
				</div>

				<div style="display: flex; margin-left: 55px;">
					<!-- <el-button size="small" class="aosit2">导出失败数据</el-button> -->
					<el-button size="small" class="aosit3" @click="reimport">重新导入</el-button>
				</div>
			</div>
		</template>

		<!-- 查看详情 -->
		<template v-if="schedule === 'importing1'">
			<!-- <div style="display: flex; justify-content: left; align-items: center;">
				<span style="width: 64px; height: 28px; font-size: 16px; font-weight: 500; color: #3b5063; line-height: 28px;"
					>导入方式</span
				>
				<el-radio v-model="radio" label="1" style="margin-left: 30px;">覆盖导入</el-radio>
				<el-radio v-model="radio" label="0" _m="l-30px">累计导入</el-radio>
			</div> -->

			<!-- 学校模版 -->
			<el-table
				:data="dataList"
				row-class-name="row"
				tooltip-effect="dark"
				:header-cell-style="{ background: '#FAFAFA', color: '#000000', height: '10px !important' }"
				width="100%"
				height="450"
				v-if="target === 'school'"
			>
				<el-table-column align="left" label="学校名称" prop="name" width="220" />
				<el-table-column align="left" label="辖区" prop="area" width="220" />
				<el-table-column align="left" label="小学" prop="primary_school">
					<template slot-scope="scope">
						<div :class="scope.row.primary_school == '是' ? 'scope-red' : ''">{{ scope.row.primary_school }}</div>
					</template>
				</el-table-column>
				<el-table-column align="left" label="初中" prop="middle_school">
					<template slot-scope="scope">
						<div :class="scope.row.middle_school == '是' ? 'scope-red' : ''">{{ scope.row.middle_school }}</div>
					</template>
				</el-table-column>
				<el-table-column align="left" label="高中" prop="high_school">
					<template slot-scope="scope">
						<div :class="scope.row.high_school == '是' ? 'scope-red' : ''">{{ scope.row.high_school }}</div>
					</template>
				</el-table-column>
				<el-table-column align="left" label="类型" prop="type" />
				<el-table-column align="left" label="层级" prop="level" />
			</el-table>

			<!-- 学生模版 -->
      <el-table
				:data="dataList"
				row-class-name="row"
				tooltip-effect="dark"
				:header-cell-style="{ background: '#FAFAFA', color: '#000000', height: '10px !important' }"
				width="100%"
				height="450"
				v-if="
					target === 'class-student' && id
				"
			>
				<el-table-column :key="1" align="left" label="学生姓名" prop="realname" />
				<el-table-column :key="2" align="left" label="性别" prop="gender" />
				<el-table-column :key="3" align="left" label="学籍号" prop="serial" :formatter="serial_formatter" />
				<el-table-column :key="4" align="left" label="班内序号" prop="number_in_class" />
			</el-table>
			<el-table
				:data="dataList"
				row-class-name="row"
				tooltip-effect="dark"
				:header-cell-style="{ background: '#FAFAFA', color: '#000000', height: '10px !important' }"
				width="100%"
				height="450"
				v-else-if="
					target === 'student' &&
					($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
						$store.state.user.userInfo.type === $api.account.types.OTHER.value) && !id
				"
			>
				<el-table-column :key="1" align="left" label="学校名称" prop="school_name" width="220" />
				<el-table-column :key="2" align="left" label="辖区" prop="area" width="220" />
				<el-table-column :key="3" align="left" label="当前年级" prop="grade_level" />
				<el-table-column :key="4" align="left" label="班号" prop="class_seq" />
				<el-table-column :key="5" align="left" label="学生姓名" prop="realname" />
				<el-table-column :key="6" align="left" label="性别" prop="gender" />
				<el-table-column :key="7" align="left" label="学籍号" prop="serial" :formatter="serial_formatter" />
				<el-table-column :key="8" align="left" label="班内序号" prop="number_in_class" />
			</el-table>
			<el-table
				:data="dataList"
				row-class-name="row"
				tooltip-effect="dark"
				:header-cell-style="{ background: '#FAFAFA', color: '#000000', height: '10px !important' }"
				width="100%"
				height="450"
				v-else-if="
					target === 'student' &&
					$store.state.user.userInfo.type !== $api.account.types.PLATFORM_ADMIN.value &&
					$store.state.user.userInfo.type !== $api.account.types.OTHER.value && !id
				"
			>
				<el-table-column :key="3" align="left" label="当前年级" prop="grade_level" />
				<el-table-column :key="4" align="left" label="班号" prop="class_seq" />
				<el-table-column :key="5" align="left" label="学生姓名" prop="realname" />
				<el-table-column :key="6" align="left" label="性别" prop="gender" />
				<el-table-column :key="7" align="left" label="学籍号" prop="serial" :formatter="serial_formatter" />
				<el-table-column :key="8" align="left" label="班内序号" prop="number_in_class" />
			</el-table>


			<!-- 班级模版 -->
			<el-table
				:data="dataList"
				row-class-name="row"
				tooltip-effect="dark"
				:header-cell-style="{ background: '#FAFAFA', color: '#000000', height: '10px !important' }"
				width="100%"
				height="450"
				v-if="
					target === 'classroom' &&
					($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
						$store.state.user.userInfo.type === $api.account.types.OTHER.value)
				"
			>
				<el-table-column :key="1" align="left" label="学校名称" prop="school_name" width="220" />
				<el-table-column :key="2" align="left" label="辖区" prop="area" width="220" />
				<el-table-column :key="3" align="left" label="当前班级所在年级" prop="enroll_grade" />
				<el-table-column :key="4" align="left" label="班级序号" prop="seq" />
			</el-table>
			<el-table
				:data="dataList"
				row-class-name="row"
				tooltip-effect="dark"
				:header-cell-style="{ background: '#FAFAFA', color: '#000000', height: '10px !important' }"
				width="100%"
				height="450"
				v-if="
					target === 'classroom' &&
					$store.state.user.userInfo.type !== $api.account.types.PLATFORM_ADMIN.value &&
					$store.state.user.userInfo.type !== $api.account.types.OTHER.value
				"
			>
				<el-table-column :key="3" align="left" label="当前班级所在年级" prop="enroll_grade" />
				<el-table-column :key="4" align="left" label="班级序号" prop="seq" />
			</el-table>

			<!-- 教师模版 -->
			<el-table
				:data="dataList"
				row-class-name="row"
				tooltip-effect="dark"
				:header-cell-style="{ background: '#FAFAFA', color: '#000000', height: '10px !important' }"
				width="100%"
				height="450"
				v-if="
					target === 'teacher' &&
					($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
						$store.state.user.userInfo.type === $api.account.types.OTHER.value)
				"
			>
				<el-table-column :key="1" align="left" label="学校名称" prop="school_name" width="220" />
				<el-table-column :key="2" align="left" label="辖区" prop="area" width="220" />
				<el-table-column :key="3" align="left" label="教师姓名" prop="realname" />
				<!-- <el-table-column :key="4" align="left" label="学科" prop="subject" /> -->
				<el-table-column :key="4" align="center" label="音乐" prop="music">
					<template slot-scope="scope">
						<div :class="scope.row.music == '是' ? 'scope-red' : ''">{{ scope.row.music }}</div>
					</template>
				</el-table-column>
				<el-table-column :key="5" align="center" label="美术" prop="art">
					<template slot-scope="scope">
						<div :class="scope.row.art == '是' ? 'scope-red' : ''">{{ scope.row.art }}</div>
					</template>
				</el-table-column>
			</el-table>
			<el-table
				:data="dataList"
				row-class-name="row"
				tooltip-effect="dark"
				:header-cell-style="{ background: '#FAFAFA', color: '#000000', height: '10px !important' }"
				width="100%"
				height="450"
				v-if="
					target === 'teacher' &&
					$store.state.user.userInfo.type !== $api.account.types.PLATFORM_ADMIN.value &&
					$store.state.user.userInfo.type !== $api.account.types.OTHER.value
				"
			>
				<el-table-column :key="3" align="left" label="教师姓名" prop="realname" />
				<!-- <el-table-column :key="4" align="left" label="学科" prop="subject" /> -->
				<el-table-column :key="4" align="center" label="音乐" prop="music">
					<template slot-scope="scope">
						<div :class="scope.row.music == '是' ? 'scope-red' : ''">{{ scope.row.music }}</div>
					</template>
				</el-table-column>
				<el-table-column :key="5" align="center" label="美术" prop="art">
					<template slot-scope="scope">
						<div :class="scope.row.art == '是' ? 'scope-red' : ''">{{ scope.row.art }}</div>
					</template>
				</el-table-column>
			</el-table>

			<!-- 校管模版 -->
			<el-table
				:data="dataList"
				row-class-name="row"
				tooltip-effect="dark"
				:header-cell-style="{ background: '#FAFAFA', color: '#000000', height: '10px !important' }"
				width="100%"
				height="450"
				v-if="target === 'school_admin'"
			>
				<el-table-column align="left" label="学校名称" prop="school_name" width="220" />
				<el-table-column align="left" label="辖区" prop="area" width="220" />
				<el-table-column align="left" label="校管名字" prop="realname" />
			</el-table>

      <!-- 教研模版 -->
      <el-table
				:data="dataList"
				row-class-name="row"
				tooltip-effect="dark"
				:header-cell-style="{ background: '#FAFAFA', color: '#000000', height: '10px !important' }"
				width="100%"
				height="450"
				v-if="target === 'assistant'"
			>
				<el-table-column align="left" label="层级" prop="level" />
				<el-table-column align="left" label="辖区" prop="area" />
				<el-table-column align="left" label="教研员名字" prop="realname" />
			</el-table>

			<div class="pagination-page">
				<span class="pagetotal">{{ totalItems }}条/{{ Math.ceil(totalItems / pageSize) }}页</span>
				<el-pagination
					class="pagination"
					background
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-size="pageSize"
					:total="totalItems"
					:current-page.sync="currentPage"
					layout="prev,pager,next"
					:page-sizes="[10, 20, 50, 100]"
					style="margin-top: 21px; margin-left: 10px;"
				>
				</el-pagination>
			</div>
			<el-divider></el-divider>
			<div
				style="display: flex; justify-content: center; align-items: center; padding-top: 15px; padding-bottom: 22px;"
			>
				<el-button size="medium" @click="reimport" style="margin-right: 30px;">重新上传</el-button>
				<el-button class="again-btn" size="medium" type="primary" @click="SendImport" style="margin-left: 30px;"
					>确认导入</el-button
				>
			</div>
		</template>

		<!-- 校检成功 -->
		<template v-if="schedule === 'import_successed'">
			<div class="uploading" style="color: #1db252;">
				<svg class="icon" aria-hidden="true" style="width: 80px; height: 80px; outline: none; box-shadow: none;">
					<use xlink:href="#icon-uploadsess"></use>
				</svg>
				<span class="uploading-font">导入成功</span>
			</div>
		</template>

		<template v-if="schedule === 'import_failed'">
			<div class="uploading" style="color: #fe5959;">
				<svg class="icon" aria-hidden="true" style="width: 80px; height: 80px; outline: none; box-shadow: none;">
					<use xlink:href="#icon-uploaderror"></use>
				</svg>
				<span class="uploading-font">导入失败</span>
			</div>
		</template>
	</el-dialog>
</template>

<script>
import Fakeprogress from 'fake-progress'
import { importXLS } from '@/utils/job.js'
//const INTERVAL_TIME = 2000 // 轮询是否已生成密码表时间间隔
//let awaitTimer = null

export default {
	props: {
		target: String,
    id: {
      default: undefined
    }
	},
	data() {
		return {
			fake: new Fakeprogress({
				timeConstant: 60000
			}),
			recordId: null,
			radio: '0',
			dataList: [],
			dialogVisible: false,
			loading: false,
			isDownloaded: false,
			schedule: 'not_imported',
			importRes: {},
			fileList: [
				{
					name: 'food.jpeg',
					url:
						'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
				},
				{
					name: 'food2.jpeg',
					url:
						'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
				}
			],
			filename: '',
			filesize: '',
			pageSize: 10,
			totalItems: 0,
			currentPage: 1,
			timer: null,
			erroris: '',
			jiID: 1,
			shuriID: 1,
      targetMap: {
        'class-student': '班级-学生',
        'student': '学生',
        'assistant': '校验',
        'school': '学校',
        'school_admin': '校管',
        'classroom': '班级',
        'teacher': '教师'
      }
		}
	},
	destroyed() {
		clearInterval(this.timer)
		this.timer = null
	},
	computed: {
		dialogTitle() {
			let title = null
			switch (this.schedule) {
				case 'not_imported':
				case 'importing':
					title = '批量创建'
					break
				case 'importingWin':
					title = '批量创建'
					break
				case 'importing1':
					title = '批量创建'
					break

				case 'importinglose':
					title = '批量创建'
					break
				case 'importinghttp':
					title = '批量创建'
					break

				case 'import_successed':
					title = '导入结果'
					break
				case 'import_failed':
					title = '导入失败'
			}
			return title
		}
	},
	methods: {
		serial_formatter(row) {
			return String(row.serial)?.replace(/\s/g, '')
		},
		beforeUpload(file) {
			const { type } = file
			if (type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') return true
			else {
				this.$message.error('文件格式不正确，请上传execl表格')
				return false
			}
		},
		stop() {
			clearInterval(this.timer)
			this.timer = null
		},
		async getProjectList() {
      try {
        let res2 = null
        res2 = await this.$api.import_account.AsyncJob(this.recordId, {
          page: this.currentPage
        })
        // if (this.jiID <= 30) {
        if (res2.result != null) {
          if (res2.result.data.success === true) {
            this.fake.end()
            await new Promise(resolve => setTimeout(resolve, 1500))
            this.dataList = res2.excel.data
            this.totalItems = res2.excel.total
            this.pageSize = parseInt(10)
            this.stop()
            this.schedule = 'importing1' /* importingWin */
          } else if (res2.result.data.success === false) {
            this.fake.end()
            this.erroris = res2.result.data.error
            this.stop()
            this.schedule = 'importinglose'
          }
        }
      } catch(_) {
        this.fake.end()
        this.stop()
        this.schedule = 'importinghttp'
      }
				// this.jiID += 1
			// } else {
			// 	this.fake.end()
			// 	// this.erroris = '校检失败，请检查导入数据是否正确后重新导入'
			// 	// this.schedule = 'importinglose'
			// 	this.stop()
			// 	this.shuriID = 2
			// 	this.schedule = 'importinghttp'
			// }
		},
		async getProjectList2() {
			let res2 = null
			res2 = await this.$api.import_account.AsyncJob(this.recordId, {
				page: this.currentPage
			})
			if (res2.result.data.success === true) {
				this.dataList = res2.excel.data
				this.totalItems = res2.excel.total
				this.pageSize = parseInt(10)
			}
		},

		async SendImport() {
			let res2 = null
			res2 = await this.$api.import_account.sendimport(this.recordId, { is_overwrite: this.radio })
			if (res2.data.result.data.success === true) {
				this.schedule = 'import_successed'
				// if (
				// 	this.target === 'school' ||
				// 	this.target === 'student' ||
				// 	this.target === 'school_admin' ||
				// 	this.target === 'teacher' ||
        //   this.target === 'assistant'
				// ) {
				// 	this.$parent.refreshDataList()
				// } else if (this.target === 'classroom') {
				// 	this.$parent.refreshDataList1()
				// }
        let job = {
          job_id: this.recordId,
          name: this.filename,
          type: 'XLS',
          stop: false,
          size: this.filesize,
        }
        importXLS(this, job)
        this.$store.state.job.isDot = true
        this.beforeClose(() => {
          this.dialogVisible = false
        })
				// this.$message.success('导入成功，请刷新数据')
			} else if (res2.data.result.data.success === false) {
				this.schedule = 'import_failed'
			}
		},
		checkdata() {
			this.schedule = 'importing1'
		},
		//每页下拉只显示的数据
		handleSizeChange(val) {
			this.pageSize = val
		},
		//当前点击的是第几页
		handleCurrentChange(currentPage) {
			this.currentPage = currentPage
			this.getProjectList2()
		},
		format(percentage) {
			return ''
		},

		handleRemove(file, fileList) {},
		readFile(file) {
			//文件读取
			return new Promise(resolve => {
				let reader = new FileReader()
				reader.readAsBinaryString(file) //以二进制的方式读取
				reader.onload = ev => {
					resolve(ev.target.result)
				}
			})
		},

		formatbytes(bytes) {
			if (bytes === 0) return '0 B'
			const k = 1024
			const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
			const i = Math.floor(Math.log(bytes) / Math.log(k))
			return (bytes / Math.pow(k, i)).toPrecision(3) + '' + sizes[i]
		},

		async reimport() {
			this.schedule = 'not_imported'
			this.shuriID = 1
			this.jiID = 1
		},
		async uploadSectionFile(param) {
			let upFile = param.file
			this.schedule = 'importing'
			this.fake.start()
			this.filename = upFile.name
			this.filesize = this.formatbytes(upFile.size)

			try {
				var res2 = await this.$api.import_account.import(this.target == 'class-student' ? 'student' : this.target, upFile, this.id)
				this.recordId = res2.record.id
				// 实现轮询
				this.timer = window.setInterval(() => {
					setTimeout(this.getProjectList(), 0)
				}, 2000)
			} catch {
				this.fake.end()
				//this.schedule = 'importinghttp'
				this.schedule = 'importinghttp'
			}
		},
		async domloadBlob(key, fileName) {
			//let blob = await this.$api.import_account.download(this.target)
      var blob
      let name = fileName
      if (this.target == 'student' && this.id) {
        blob = await this.$api.import_account.download('class-student')
        name = '班级-学生模版'
      } else {
        blob = await this.$api.import_account.download(this.target)
      }
			this.downloadFile(blob, name)
		},

		async domloadBlob2(key, fileName) {
			//let blob = await this.$api.import_account.download(this.target)
			let blob = await this.$api.import_account.download2(this.recordId)
			this.downloadFile(blob, fileName)
		},
		downloadFile(blob, fileName) {
			const url = window.URL.createObjectURL(new Blob([blob]))
			let a = document.createElement('a')
			a.href = url
			// 保证下载文件后缀一致
			a.download = `${fileName}.xlsx`
			a.click()
			window.URL.revokeObjectURL(url)
		},
		async beforeClose(done) {
			this.isDownloaded = false
			this.schedule = 'not_imported'
			this.importRes = {}
			clearInterval(this.timer)
			this.timer = null
			this.shuriID = 1
			this.jiID = 1
			done()
		}
	}
	// mounted() {
	// }
}
</script>

<style lang="scss" scoped>
.scope-red {
	color: red;
}

::-webkit-scrollbar {
	width: 6px;
}

::-webkit-scrollbar-track {
	background-color: #f3f3f3;
}

::-webkit-scrollbar-thumb {
	background-color: #aaa;
}

::-webkit-scrollbar-thumb:hover {
	background-color: #aaa;
}

::-webkit-scrollbar-thumb:active {
	background-color: #aaa;
}

.pagetotal {
	width: 250px;
	margin-left: 20px;
	font-size: 14px;
	line-height: 76px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #010101;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
	float: right;
	text-align: right;
}
.pagination-page {
	height: 55px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: right;
	-ms-flex-pack: right;
	justify-content: right;
	-webkit-box-align: right;
	-ms-flex-align: right;
	align-items: right;
	margin-top: 1.5px;
	padding-right: 10px;
	background: white;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}
.school-mgn-list .el-table {
	min-height: 440px;
	max-height: 440px;
}

.jhrts {
	margin-top: 5px;
	margin-left: 10px;
	display: flex;
	flex-direction: column;
	justify-content: left;
	align-items: left;
	width: 65%;
	padding-right: 10px;
}
.aosit {
	height: 33px;
	background: #ffffff;
	border-radius: 4px 4px 4px 4px;
	opacity: 1;
	border: 1px solid #3f9b54;
	color: #3f9b54 !important;
	margin-right: 15px;
}
.aosit:hover {
	background: #c9f1d3;
	border: 1px solid #3f9b54;
}
.aosit2 {
	background: #ffffff;
	border-radius: 4px 4px 4px 4px;
	opacity: 1;
	border: 1px solid #505968;
	color: #505968 !important;
}
.aosit3 {
	background: #ffffff;
	border-radius: 4px 4px 4px 4px;
	opacity: 1;
	border: 1px solid #fe5d29;
	color: #fe5d29 !important;
}

.uploading-hdmi {
	height: 80px;
	background-color: #f9fafc;
	margin-bottom: 80px;
	display: flex;
	justify-content: left;
	align-items: center;
	margin-left: 20px;
	margin-right: 20px;
	vertical-align: middle;
	/* display: flex;
	justify-content: space-between;
	background: #fff;
	height: 65px; */
}
.uploading-sasi {
	width: 100%;
	height: 22px;
	font-size: 16px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #1d1d1d;
	line-height: 22px;
	-webkit-background-clip: text;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}
.uploading-kenhtid {
	width: 93px;
	margin-top: 5px;
	max-height: 50px;
	font-size: 10px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #4b4b4b;
	line-height: 20px;
	-webkit-background-clip: text;
	overflow: auto;
}

.uploading {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 200px;
	background: #fff;
}
.uploading-font {
	margin-top: 10px;

	font-size: 15px;
	font-family: PingFang SC-Bold, PingFang SC;
	font-weight: bold;
	color: #1d1d1d;

	-webkit-background-clip: text;
}
.batch-import-account-dialog {
	.topon-upload {
		height: 60px;
		background-color: #f9fafc;
		border-radius: 6px 6px 6px 6px;
		opacity: 1;
		border: 1px solid #dddddd;
		padding-left: 20px;
		line-height: 70px;

		.topon-p {
			font-size: 14px;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			line-height: 60px;
			-webkit-background-clip: text;
			.template {
				cursor: pointer;
				color: #3e9ef4;
			}
		}
	}
	.upload-demo {
		//padding: 50px 10px 0px 10px;
		background-color: #f9fafc;
		margin-top: 15px;
		margin-bottom: 15px;
		height: 300px;
		border-radius: 6px 6px 6px 6px;
		opacity: 1;
		border: 1px solid #dddddd;
	}

	/deep/.el-upload-dragger {
		width: 530px;
		height: 225px;
		margin-left: 15px;
	}
}
</style>
